export default class Debate {
  constructor(data) {
    for (let i in data) {
      this[i] = data[i];
      this.remainingDays = this.getRemainingTime(this.endedAt);
    }

    if (this.sides) {
      const mostVoted = Math.max(...this.sides.map((side) => side.votes));

      for (let i in this.sides) {
        const side = this.sides[i];
        let percent = ((side.votes / this.votes) * 100).toFixed(1);
        percent = isNaN(parseInt(percent)) ? "0" : percent;

        this.sides[i].percent = percent;
        this.sides[i].isMostVoted = mostVoted === this.sides[i].votes;
      }
    }
  }

  correctPercent() {
    const correctSide = this.sides.find((side) => side.isCorrect);

    return correctSide ? correctSide.percent : 0;
  }

  votedSide() {
    if (this.votedSideId) {
      const votedSide = this.sides.find((side) => side.id === this.votedSideId);

      if (votedSide) {
        return votedSide;
      }
    }

    return null;
  }

  getRemainingTime(date) {
    const duration = (new Date(date) - new Date()) / 1000;
    const days = Math.floor(duration / 60 / 60 / 24);

    let hours = 0;

    if (days === 0) {
      hours = Math.floor(duration / 60 / 60);

      if (hours === 0) {
        const minutes = Math.floor(duration / 60);

        if (minutes === 0) {
          return "1 minute";
        }

        return minutes + " " + (minutes === 1 ? "minute" : "minutes");
      }

      return hours + " " + (hours === 1 ? "hour" : "hours");
    }

    let daysPart = days + " " + (days === 1 ? "day" : "days");
    daysPart = daysPart === "0 days" ? "today" : daysPart;

    return daysPart;
  }
}
